import React from 'react';

export const EvShlText = () => {
  return (
    <p>
      Шлях, який забезпечує рух людей до виходу. Зазвичай це проходи, коридори, сходи, тамбури, фоє, холи, вестибюлі. Як
      евакуаційний <b>не використовують </b>
      шлях, що пов’язаний з механічним приводом (ліфти, ескалатори), оскільки при пожежі або аварії вони можуть вийти з
      ладу.
    </p>
  );
};
